import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

/* ================= ÁNH XẠ ẢNH VÀO THƯ MỤC SRC/ASSETS/ABOUT ================= */
/*import aboutHero1 from "./assets/about/about_hero_bouquet.webp";*/ // Một bức hình chụp bó hoa mình làm đẹp nhất
import aboutHero2 from "./assets/about/about_hero_team.webp";       // Hình chụp team
import fullBanner from "./assets/about/about_full_banner.webp";     // Ảnh thợ cắm hoa góc từ trên xuống
import storyImg from "./assets/about/about_story.webp";             // Ảnh cô gái ngắm hoa
import featureBg from "./assets/about/about_feature_bg.webp";       // Ảnh nền tối cho phần "Vì sao chọn..."
import core1 from "./assets/about/core_1.webp";
import core2 from "./assets/about/core_2.webp";
import core3 from "./assets/about/core_3.webp";
import partnerLogos from "./assets/about/partner_logos.webp";
import logoImg from "./assets/LOGO.png";

export default function Vechungtoi() {
  const navigate = useNavigate();

  // Inject Font chữ sang trọng (Google Fonts)
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,400&family=Pinyon+Script&family=Montserrat:wght@300;400;500&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  // State cho phần FAQ (Accordion)
  const [activeFaq, setActiveFaq] = useState(null);
  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const faqs = [
    { q: "Hoa có được giao ngay trong ngày không?", a: "Floraison hỗ trợ giao hàng hoả tốc trong vòng 2H đối với các mẫu hoa có sẵn nguyên liệu tại cửa hàng." },
    { q: "Tôi có thể tự mang phụ kiện đến để gói cùng hoa không?", a: "Hoàn toàn có thể. Chúng tôi luôn khuyến khích bạn cá nhân hoá bó hoa của mình bằng những kỷ vật riêng." },
    { q: "Làm sao để biết hoa thực tế giống với thiết kế của tôi?", a: "Trước khi giao, Floraison sẽ chụp lại thành phẩm và gửi cho bạn xác nhận để đảm bảo mọi chi tiết đều hoàn hảo." }
  ];

  const [isCtaHover, setIsCtaHover] = React.useState(false);

  return (
    <div style={styles.pageContainer}>
      <style>{`
        /* ================= RESET DEFAULT BROWSER STYLES LÀM HỞ LỀ ================= */
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          width: 100% !important;
          overflow-x: hidden !important; /* Xoá thanh cuộn ngang gây lỗi giao diện */
        }
        * {
          box-sizing: border-box !important;
        }

        /* ================= BANNER TEAM RỘNG FULL, CAO 70% MÀN HÌNH (LAYER DƯỚI CÙNG) ================= */
        .hero-image-collage {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          transform: none !important;
          z-index: 0 !important; /* Đẩy xuống đáy cùng dưới mọi layout */
          width: 100% !important; /* Tránh tràn màn hình mobile */
          height: 75vh !important; /* Cao đúng 70% màn hình */
          overflow: hidden !important;
        }

        .hero-img-secondary {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important; /* Co giãn ảnh không bị méo */
          position: static !important; 
          margin-left: 0 !important;
          box-shadow: none !important;
        }

        /* KHỐI CHỮ CHỨA NỘI DUNG "FLORAISON YOUR FEELINGS" */
        .hero-text-content {
          position: relative !important;
          z-index: 2 !important;
          background-color: #ffffff !important; /* Nền đặc để đè lên ảnh */
          width: 100% !important;
          margin-top: 75vh !important; /* Đẩy chữ xuống đúng bằng chiều cao banner */
          padding: 10px 5% 100px !important;
        }

        /* ĐẢM BẢO CÁC SECTION KHÁC KHI CUỘN ĐỀU ĐÈ LÊN BANNER CHỨ KHÔNG BỊ CHÌM */
        .full-banner-section, 
        .story-section, 
        .feature-section, 
        .core-values-section, 
        .partner-section, 
        .faq-section {
          position: relative !important;
          z-index: 2 !important;
        }

        /* ================= HOVER EFFECT FOR CTA BUTTON ================= */
        .btn-luxury-outline.cta-button {
          background-color: #ffffff !important;
          color: #000000 !important;
          border: 1px solid #000000 !important;
          transition: all 0.3s ease-in-out !important;
        }

        .btn-luxury-outline.cta-button:hover {
          background-color: #000000 !important;
          color: #ffffff !important;
        }

        .hero-decor-wave {
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: clip !important;
          width: 100% !important;
        }

        /* ================= RESPONSIVE ĐỒNG BỘ THEO TỶ LỆ % MÀN HÌNH ================= */
        /* Mobile: Small phones (< 480px) */
        @media (max-width: 480px) {
          .hero-image-collage {
            height: 75vh !important; 
          }
          .hero-text-content {
            margin-top: 75vh !important; 
            padding: 50px 24px 60px !important;
          }
          .hero-decor-wave {
            font-size: 12px !important;
            top: 20px !important;
            padding: 0 15px !important;
          }
          .main-title {
            font-size: 30px !important;
            margin-bottom: 20px !important;
            line-height: 1.2 !important;
          }
          .main-desc {
            font-size: 13px !important;
            line-height: 1.7 !important;
            margin-bottom: 30px !important;
            padding: 0 !important;
            text-align: justify;
          }
          .cta-button {
            padding: 14px 24px !important;
            font-size: 11px !important;
            letter-spacing: 1px !important;
            width: 100% !important;
            text-align: center !important;
          }
          
          /* Full Banner */
          .full-banner-section {
            height: 35vh !important;
            min-height: 220px !important;
          }
          .banner-logo-badge {
            width: 150px !important;
            height: 150px !important;
          }
          
          /* Story Section */
          .story-section {
            padding: 60px 20px !important;
          }
          .story-title-wrapper {
            margin-bottom: 35px !important;
          }
          .script-title {
            font-size: 32px !important;
          }
          .section-title {
            font-size: 26px !important;
          }
          .story-content-grid {
            flex-direction: column !important;
            gap: 30px !important;
            max-width: 100% !important;
          }
          .story-img-wrapper {
            flex: 1 1 100% !important;
            width: 100% !important;
          }
          .story-text-wrapper {
            flex: 1 1 100% !important;
          }
          .story-text {
            font-size: 13px !important;
            line-height: 1.7 !important;
            text-align: justify;
          }
          .signature {
            font-size: 28px !important;
            margin-top: 20px !important;
            text-align: right !important;
          }
          
          /* Feature Section */
          .feature-section {
            padding: 60px 20px !important;
          }
          .feature-bg-img {
            width: 100% !important;
            height: 100% !important;
            object-position: center !important; 
          }
          .feature-grid {
            gap: 25px !important;
            grid-template-columns: 1fr !important;
          }
          .feature-item-title {
            font-size: 19px !important;
          }
          .feature-item-desc {
            font-size: 12px !important;
          }
          .feature-line {
            width: 30px !important;
          }
          
          /* Core Values */
          .core-values-section {
            padding: 60px 20px !important;
          }
          .core-title-wrapper {
            margin-bottom: 50px !important;
          }
          .core-title-decor {
            margin: 15px auto 0 !important;
          }
          .core-grid {
            gap: 55px !important; 
            flex-direction: column !important;
            max-width: 100% !important;
          }
          .core-card {
            flex: 1 1 100% !important;
            width: 100% !important;
          }
          .core-number {
            width: 60px !important;
            height: 60px !important;
            font-size: 22px !important;
            margin: -50px auto 15px !important;
          }
          .core-item-title {
            font-size: 22px !important;
          }
          .core-item-text {
            font-size: 13px !important;
            line-height: 1.6 !important;
          }
          
          /* Partners */
          .partner-section {
            padding: 60px 20px !important;
          }
          .partner-title {
            font-size: 24px !important;
            margin-bottom: 10px !important;
          }
          .partner-logos-img {
            max-width: 100% !important;
          }
          
          /* FAQ */
          .faq-section {
            padding: 60px 20px 80px !important;
          }
          .faq-container {
            max-width: 100% !important;
            margin-top: 30px !important;
          }
          .faq-question {
            padding: 16px 0 !important;
            font-size: 14px !important;
          }
          .faq-answer {
            font-size: 13px !important;
            padding-bottom: 15px !important;
          }
        }

        /* Tablet: Medium devices */
        @media (min-width: 481px) and (max-width: 1024px) {
          .hero-image-collage {
            height: 65vh !important;
            width: 100% !important;
          }
          .hero-text-content {
            margin-top: 65vh !important;
            padding: 60px 5% 80px !important;
          }
          .main-title {
            font-size: 45px !important;
          }
          .main-desc {
            font-size: 14px !important;
            line-height: 1.8 !important;
          }
          .full-banner-section {
            height: 45vh !important;
          }
          .banner-logo-badge {
            width: 220px !important;
            height: 220px !important;
          }
          .story-section {
            padding: 80px 5% !important;
          }
          .story-title-wrapper {
            margin-bottom: 60px !important;
          }
          .script-title {
            font-size: 42px !important;
          }
          .section-title {
            font-size: 32px !important;
          }
          .story-content-grid {
            flex-direction: column !important;
            gap: 40px !important;
          }
          .story-text {
            font-size: 14px !important;
            line-height: 1.8 !important;
          }
          .signature {
            font-size: 32px !important;
          }
          .feature-section {
            padding: 80px 5% !important;
          }
          .feature-bg-img {
            width: 100% !important;
            height: 100% !important;
            object-position: center !important;
          }
          .feature-grid {
            gap: 30px !important;
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .feature-item-title {
            font-size: 21px !important;
          }
          .feature-item-desc {
            font-size: 13px !important;
          }
          .core-values-section {
            padding: 80px 5% !important;
          }
          .core-title-wrapper {
            margin-bottom: 60px !important;
          }
          .core-grid {
            gap: 40px !important;
            flex-direction: row !important;
            flex-wrap: wrap !important;
          }
          .core-card {
            flex: 1 1 calc(50% - 20px) !important;
          }
          .core-number {
            width: 70px !important;
            height: 70px !important;
            font-size: 26px !important;
            margin: -55px auto 15px !important;
          }
          .core-item-title {
            font-size: 24px !important;
          }
          .core-item-text {
            font-size: 14px !important;
          }
          .partner-section {
            padding: 80px 5% !important;
          }
          .partner-title {
            font-size: 28px !important;
          }
          .partner-logos-img {
            max-width: 90% !important;
          }
          .faq-section {
            padding: 80px 5% 100px !important;
          }
          .faq-question {
            padding: 18px 0 !important;
            font-size: 15px !important;
          }
          .faq-answer {
            font-size: 14px !important;
          }
        }

        /* ================= LAPTOP & MEDIUM DESKTOPS BREAKPOINT (1025px - 1536px) ================= */
        /* Đây là phân khúc màn hình của các tester đang phản hồi lỗi tràn trang/phải zoom 80% */
        @media (min-width: 1025px) and (max-width: 1536px) {
          .hero-image-collage {
            height: 75vh !important;
          }
          .hero-text-content {
            margin-top: 70vh !important;
            padding: 5px 8% 100px !important;
          }
          .main-title {
            font-size: 52px !important; /* Co chữ tiêu đề hợp lý trên Laptop */
            margin-bottom: 20px !important;
          }
          .main-desc {
            font-size: 14px !important;
            line-height: 1.8 !important;
            margin-bottom: 30px !important;
          }
          .story-section, 
          .feature-section, 
          .core-values-section, 
          .partner-section, 
          .faq-section {
            padding: 80px 5% !important; /* Tối ưu lại khoảng cách padding tránh kéo dãn quá dài */
          }
          .script-title {
            font-size: 46px !important;
          }
          .section-title {
            font-size: 34px !important;
          }
          .story-content-grid {
            gap: 40px !important;
          }
          .feature-bg-img {
            width: 100% !important;
            left: 0 !important;
            object-position: center !important; /* Đưa ảnh về tâm để không bị khoảng trống do offset cứng */
          }
          .feature-grid {
            gap: 30px !important;
          }
          .core-grid {
            gap: 30px !important;
          }
          .core-card {
            flex: 1 1 calc(33.333% - 20px) !important;
          }
        }
      `}</style>

      {/* 1. HERO SECTION (Parallax Fixed Background) */}
      <section style={styles.heroSection} className="hero-section">
        {/* Banner team giữ cố định ở đáy */}
        <div style={styles.heroImageCollage} className="hero-image-collage">
          <motion.img initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.2 }} src={aboutHero2} alt="Floraison Team" style={styles.heroImgSecondary} className="hero-img-secondary" />
          <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1, delay: 0.5 }} style={styles.heroDecorWave} className="hero-decor-wave" >
            〰〰〰〰〰〰〰〰〰〰〰〰〰〰〰
          </motion.div>
        </div>

        {/* Khung nội dung trượt lên đè hình */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.4 }} style={styles.heroTextContent} className="hero-text-content" >
          <h1 style={styles.mainTitle} className="main-title">Floraison Your Feelings</h1>
          <p style={styles.mainDesc} className="main-desc">
            Trong tiếng Pháp, "Floraison" mang ý nghĩa là sự nở rộ. Tại Floraison, chúng tôi tin rằng mọi cảm xúc đều xứng đáng được đơm hoa. Thay vì chọn những mẫu mã đại trà, bạn được trao quyền để tự tay "hữu hình hoá" tâm ý của mình. Từng cành hoa bạn chọn, lớp giấy bạn bọc chính là cách để những yêu thương ẩn giấu được 'nở rộ' thành một thông điệp độc bản và trọn vẹn ý nghĩa.
          </p>
          <button
            style={styles.ctaButton}
            className="btn-luxury-outline cta-button"
            onClick={() => navigate("/thiet-ke-bo-hoa")}
            onMouseEnter={() => setIsCtaHover(true)}
            onMouseLeave={() => setIsCtaHover(false)}
          >
            Bắt đầu thiết kế bó hoa của bạn
          </button>
        </motion.div>
      </section>

      {/* 2. FULL WIDTH BANNER */}
      <section style={styles.fullBannerSection} className="full-banner-section">
        <motion.img initial={{ scale: 1.05 }} whileInView={{ scale: 1 }} viewport={{ once: true }} transition={{ duration: 1.5 }} src={fullBanner} alt="Florist Workspace" style={styles.fullBannerImg} className="full-banner-img" />
        <div style={styles.bannerOverlay}>
          <div style={styles.bannerLogoBadge} className="banner-logo-badge">
            <img src={logoImg} alt="Logo" style={styles.badgeLogo} />
          </div>
        </div>
      </section>

      {/* 3. STORY SECTION (Vision & Mission) */}
      <section style={styles.storySection} className="story-section">
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 1 }} style={styles.storyTitleWrapper} className="story-title-wrapper" >
          <h3 style={styles.scriptTitle} className="script-title">The story of</h3>
          <h2 style={styles.sectionTitle} className="section-title">Floraison</h2>
        </motion.div>
        <div style={styles.storyContentGrid} className="story-content-grid">
          <motion.div initial={{ opacity: 0, x: -40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 1 }} style={styles.storyImgWrapper} className="story-img-wrapper" >
            <img src={storyImg} alt="Floraison Story" style={styles.storyImg} className="story-img" />
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 1 }} style={styles.storyTextWrapper} className="story-text-wrapper" >
            <p style={styles.storyText} className="story-text">
              Mọi chuyện bắt đầu từ một lần loay hoay rất lâu trong việc lựa chọn một bó hoa đẹp để tặng mẹ, từ việc cẩn thận lựa chọn từng gam màu, cho đến cách gói ghém sao cho mang đậm dấu ấn riêng nhất, tôi nhận ra mình lại hoàn toàn "bất lực" khi bước vào thế giới của hoa tươi.
            </p>
            <p style={styles.storyText} className="story-text">
              Hoa vốn là ngôn ngữ tuyệt vời nhất của cảm xúc. Nhưng những mẫu hoa hiện tại trên thị trường, cùng với mẫu mã sẵn có, lại khó có thể thể hiện được điều ấy. Từ sự thấu hiểu đó, một câu hỏi lớn được đặt ra: Tại sao việc đặt một bó hoa không thể mang lại sự chủ động và trọn vẹn cảm xúc như khi ta tự tay làm nên một tác phẩm mang đậm tính cá nhân? Tại sao không có một nơi để người tặng được tự do sáng tạo, nhìn thấy ngay thành quả của mình và làm chủ hoàn toàn ngân sách?
            </p>
            <p style={styles.storyText} className="story-text">
              Và Floraison ra đời. Không đơn thuần là một nền tảng bán hoa, mà là một "không gian chế tác" trực tuyến. Tại Floraison, mỗi nhành hoa bạn chọn, mỗi lớp giấy bạn phối đều là một cách kể chuyện. Chúng tôi phá vỡ những giới hạn rập khuôn của thị trường để cung cấp cho bạn nguyên liệu và công cụ. Còn bạn, chính là người nghệ sĩ hiện thực hóa những xúc cảm vô hình, để tâm ý của riêng bạn được thực sự "nở rộ".
            </p>
            <div style={styles.signature} className="signature">Floraison Team</div>
          </motion.div>
        </div>
      </section>

      {/* 4. WHY CHOOSE US (Dark Feature Section) */}
      <section style={styles.featureSection} className="feature-section">
        <img src={featureBg} alt="Dark Floral Background" style={styles.featureBgImg} className="feature-bg-img" />
        <div style={styles.featureOverlay} className="feature-overlay">
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} style={{...styles.sectionTitle, color: "#ffffff", marginBottom: "60px"}} className="section-title" >
            Vì sao bạn chọn Floraison?
          </motion.h2>
          <div style={styles.featureGrid} className="feature-grid">
            {[
              { title: "Tự tay thiết kế", desc: "Bó hoa của riêng bạn" },
              { title: "Mật ngữ loài hoa", desc: "& Thiệp viết tay" },
              { title: "Giao hàng hoả tốc", desc: "An toàn & Nhanh chóng" },
              { title: "Đa dạng nguyên liệu", desc: "Thay mới mỗi ngày" }
            ].map((item, idx) => (
              <motion.div key={idx} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.15 }} style={styles.featureItem} className="feature-item" >
                <div style={styles.featureLine} className="feature-line"></div>
                <h4 style={styles.featureItemTitle} className="feature-item-title">{item.title}</h4>
                <p style={styles.featureItemDesc} className="feature-item-desc">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. CORE VALUES (CỐT LÕI) */}
      <section style={styles.coreValuesSection} className="core-values-section">
        <div style={styles.coreTitleWrapper} className="core-title-wrapper">
          <h2 style={styles.sectionTitle} className="section-title">Cốt lõi</h2>
          <div style={styles.coreTitleDecor} className="core-title-decor"></div>
        </div>
        <div style={styles.coreGrid} className="core-grid">
          {[
            { img: core1, title: "Sáng Tạo", text: "Tự do chế tác tác phẩm mang đậm tính cá nhân." },
            { img: core2, title: "Tận Tâm", text: "Chăm chút từng cành hoa, từng lớp giấy bọc." },
            { img: core3, title: "Chất Lượng", text: "Hoa tươi tuyển chọn từ các nông trại hàng đầu." }
          ].map((core, idx) => (
            <motion.div key={idx} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.2 }} style={styles.coreCard} className="core-card" >
              <div style={styles.coreImgWrapper} className="core-img-wrapper">
                <img src={core.img} alt={core.title} style={styles.coreImg} className="core-img" />
              </div>
              <div style={styles.coreNumber} className="core-number">{idx + 1}</div>
              <h4 style={styles.coreItemTitle} className="core-item-title">{core.title}</h4>
              <p style={styles.coreItemText} className="core-item-text">{core.text}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 6. PARTNERS LOGOS */}
      <section style={styles.partnerSection} className="partner-section">
        <motion.h3 initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} style={styles.partnerTitle} className="partner-title" >
          Thương hiệu đồng hành
        </motion.h3>
        <p style={{textAlign: 'center', marginBottom: '40px', color: '#666'}}>
          Bảo chứng chất lượng từ các thương hiệu hàng đầu
        </p>
        <motion.img initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} src={partnerLogos} alt="Partners" style={styles.partnerLogosImg} className="partner-logos-img" />
      </section>

      {/* 7. FAQ SECTION */}
      <section style={styles.faqSection} className="faq-section">
        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} style={styles.sectionTitle} className="section-title" >
          Các câu hỏi thường gặp
        </motion.h2>
        <div style={styles.faqContainer} className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} style={styles.faqItem} className="faq-item">
              <div style={styles.faqQuestion} onClick={() => toggleFaq(index)} className="faq-question" >
                <span>{faq.q}</span>
                <span style={styles.faqIcon} className="faq-icon">{activeFaq === index ? "−" : "+"}</span>
              </div>
              <AnimatePresence>
                {activeFaq === index && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} style={{ overflow: "hidden" }} >
                    <p style={styles.faqAnswer} className="faq-answer">{faq.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

/* ================= JSS STYLING MỚI ================= */
const styles = {
  pageContainer: {
    fontFamily: '"Montserrat", sans-serif',
    backgroundColor: "transparent", /* Phải để transparent thì mới nhìn thấy hình ảnh ghim ở lớp -1 */
    color: "#222",
    overflowX: "hidden",
  },
  /* CHUNG */
  sectionTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "clamp(32px, 4vw, 42px)",
    fontWeight: 400,
    textAlign: "center",
    letterSpacing: "1px",
    margin: "0",
  },
  scriptTitle: {
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "clamp(40px, 5vw, 60px)",
    color: "#4a5a3a",
    fontWeight: 400,
    margin: "0 0 -15px 0",
    textAlign: "center",
  },
  /* 1. HERO SECTION */
  heroSection: {
    position: "relative",
    width: "100%",
    overflow: "hidden", /* Tăng cường bảo vệ chống tràn */
  },
  heroImageCollage: {
    position: "relative",
  },
  heroDecorWave: {
    position: "absolute",
    top: "30px",
    left: 0,
    width: "100%",
    textAlign: "center",
    fontSize: "24px",
    color: "#ffffff", /* Đổi sóng lượn sang màu trắng cho nổi bật trên ảnh cover */
    letterSpacing: "2px",
    zIndex: 3,
  },
  heroImgSecondary: {
    position: "absolute",
    top: "-20px",
    bottom: "-80px",
    left: 0,
    width: "130%",
    marginLeft: "-15%",
    aspectRatio: "16/9",
    objectFit: "cover",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  },
  heroTextContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  mainTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "clamp(40px, 6vw, 70px)",
    fontWeight: 400,
    marginBottom: "30px",
    color: "#222",
  },
  mainDesc: {
    fontSize: "15px",
    lineHeight: "2",
    color: "#555",
    marginBottom: "40px",
    maxWidth: "700px",
    margin: "0 auto 40px",
  },
  ctaButton: {
    padding: "16px 40px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "14px",
    textTransform: "uppercase",
    letterSpacing: "2px",
    cursor: "pointer",
  },
  /* 2. FULL BANNER */
  fullBannerSection: {
    position: "relative",
    width: "100%",
    height: "60vh",
    overflow: "hidden",
    backgroundColor: "#ffe1f7", /* Đổ màu nền kín để đè lên banner */
  },
  fullBannerImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  bannerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  bannerLogoBadge: {
    width: "300px",
    height: "300px",
    border: "1px solid #fff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.52)",
    backdropFilter: "blur(4px)",
    overflow: "hidden",
    padding: "10px",
  },
  badgeLogo: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.2))",
  },
  /* 3. STORY SECTION */
  storySection: {
    padding: "120px 5%",
    backgroundColor: "#ffffff", /* Đổ màu nền kín để đè lên banner */
  },
  storyTitleWrapper: {
    marginBottom: "80px",
  },
  storyContentGrid: {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: "1100px",
    margin: "0 auto",
    gap: "60px",
    alignItems: "center",
  },
  storyImgWrapper: {
    flex: "1 1 400px",
  },
  storyImg: {
    width: "100%",
    height: "auto",
    aspectRatio: "3/4",
    objectFit: "cover",
  },
  storyTextWrapper: {
    flex: "1 1 400px",
  },
  storyText: {
    fontSize: "14px",
    lineHeight: "2",
    color: "#555",
    marginBottom: "20px",
  },
  signature: {
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "36px",
    color: "#4a5a3a",
    marginTop: "30px",
  },
  /* 4. FEATURE SECTION */
  featureSection: {
    position: "relative",
    width: "100%",
    padding: "120px 5%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflow: "hidden", /* FIX: Khóa tràn viền từ ảnh nền 120% rộng */
  },
  featureBgImg: {
    position: "absolute",
    top: "0px",
    left: 0,
    width: "120%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "0px -580px",
    zIndex: 1,
  },
  featureOverlay: {
    position: "relative",
    zIndex: 2,
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "40px",
  },
  featureItem: {
    color: "#fff",
  },
  featureLine: {
    width: "40px",
    height: "1px",
    backgroundColor: "#fff",
    marginBottom: "20px",
  },
  featureItemTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "24px",
    fontWeight: 400,
    marginBottom: "10px",
  },
  featureItemDesc: {
    fontSize: "13px",
    color: "#ccc",
    lineHeight: "1.6",
  },
  /* 5. CORE VALUES */
  coreValuesSection: {
    padding: "120px 5%",
    backgroundColor: "#e8ede5", /* Đổ màu nền kín để đè lên banner */
  },
  coreTitleWrapper: {
    textAlign: "center",
    marginBottom: "80px",
  },
  coreTitleDecor: {
    width: "60px",
    height: "1px",
    backgroundColor: "#4a5a3a",
    margin: "20px auto 0",
  },
  coreGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "40px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  coreCard: {
    flex: "1 1 300px",
    textAlign: "center",
    position: "relative",
  },
  coreImgWrapper: {
    width: "100%",
    aspectRatio: "3/4",
    overflow: "hidden",
    marginBottom: "30px",
  },
  coreImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  coreNumber: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "#4a5a3a",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    paddingBottom: "7px",
    justifyContent: "center",
    margin: "-70px auto 20px",
    position: "relative",
    zIndex: 2,
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "30px",
    lineHeight: 1,
  },
  coreItemTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "26px",
    fontWeight: 400,
    marginBottom: "15px",
  },
  coreItemText: {
    fontSize: "14px",
    lineHeight: "1.8",
    color: "#555",
  },
  /* 6. PARTNERS */
  partnerSection: {
    padding: "100px 5%",
    backgroundColor: "#ffffff", /* Đổ màu nền kín để đè lên banner */
    textAlign: "center",
  },
  partnerTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "32px",
    fontWeight: 400,
    marginBottom: "15px",
  },
  partnerLogosImg: {
    maxWidth: "800px",
    width: "100%",
    height: "auto",
    opacity: 0.7,
  },
  /* 7. FAQ */
  faqSection: {
    padding: "80px 5% 120px",
    backgroundColor: "#ffffff", /* Đổ màu nền kín để đè lên banner */
  },
  faqContainer: {
    maxWidth: "800px",
    margin: "60px auto 0",
  },
  faqItem: {
    borderBottom: "1px solid #eaeaea",
  },
  faqQuestion: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 0",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 500,
  },
  faqIcon: {
    fontSize: "24px",
    color: "#999",
    fontWeight: 300,
  },
  faqAnswer: {
    fontSize: "14px",
    lineHeight: "1.8",
    color: "#666",
    paddingBottom: "20px",
  }
};